"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transformCoordinates;

var _proj = _interopRequireDefault(require("proj4"));

var _proj2 = require("ol/proj");

var _proj3 = require("ol/proj/proj4");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

_proj.default.defs('EPSG:4258', '+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs');

_proj.default.defs('EPSG:25831', '+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs');

_proj.default.defs('EPSG:25832', '+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs');

_proj.default.defs('EPSG:25833', '+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs');

_proj.default.defs('EPSG:25834', '+proj=utm +zone=34 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs');

_proj.default.defs('EPSG:25835', '+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs');

_proj.default.defs('EPSG:25836', '+proj=utm +zone=36 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs');

(0, _proj3.register)(_proj.default);

function transformCoordinates(coordinates, fromProjection) {
  var toProjection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'EPSG:4258';
  return (0, _proj2.transform)(coordinates, fromProjection, toProjection);
}